import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from './NavBar';
import './Blog.css';

function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blog-page">
      <NavBar />

      {/* Hero Section */}
      <section className="blog-hero">
        <div className="blog-hero-content">
          <h1>Blog</h1>
          <p className="blog-subtitle">Insights on AI agent orchestration</p>
        </div>
      </section>

      {/* Blog Content */}
      <div className="blog-content">

        {/* Article 3: Percolation Theory */}
        <article className="blog-article">
          <Link to="/blog/percolation-emergent-capability" className="article-link">
            <h2>Phase Transitions and Emergent Capabilities in AI Systems</h2>
            <p className="article-meta">September 8, 2024 • 15 min read</p>
            <p className="article-excerpt">
              Why do AI capabilities sometimes appear suddenly? We explore how percolation theory and phase
              transitions explain emergent abilities in AI systems. From geometric failure in sequential
              reasoning to the mathematics of critical thresholds, discover why small improvements in
              reliability can trigger exponential jumps in what agents can accomplish.
            </p>
            <div className="article-preview-image">
              <img src="/percolation.gif" alt="Animated visualization of percolation phase transition" style={{ maxWidth: '50%' }} />
              <p className="image-credit">Phase transition visualization</p>
            </div>
            <div className="article-tags">
              <span className="tag">Theory</span>
              <span className="tag">Mathematics</span>
              <span className="tag">Emergent Behavior</span>
            </div>
          </Link>
        </article>

        {/* Article 2: Hierarchical Structure */}
        <article className="blog-article">
          <Link to="/blog/hierarchical-agents" className="article-link">
            <h2>Hierarchical Agent Systems: Unlocking Exponential Coherence Horizons</h2>
            <p className="article-meta">June 22, 2024 • 12 min read</p>
            <p className="article-excerpt">
              Explore how hierarchical agent architectures can exponentially extend the coherence horizon
              of LLMs. While individual models can maintain focus for N tokens, structured delegation to
              sub-agents operating at decreasing levels of abstraction enables complex, long-running tasks.
              We'll examine both the potential and the practical limitations, including the "lost in translation"
              degradation that occurs during inter-agent communication.
            </p>
            <div className="article-tags">
              <span className="tag">Architecture</span>
              <span className="tag">Multi-Agent Systems</span>
              <span className="tag">Research</span>
            </div>
          </Link>
        </article>

        {/* Article 1: Function Calling */}
        <article className="blog-article">
          <Link to="/blog/function-calling" className="article-link">
            <h2>Understanding Function Calling in LLMs</h2>
            <p className="article-meta">January 15, 2024 • 8 min read</p>
            <p className="article-excerpt">
              Learn how language models can interact with external tools through function calling.
              We'll walk through a practical example using a simple division tool to demonstrate
              how agents can extend their capabilities beyond text generation.
            </p>
            <div className="article-preview-image">
              <img src="/function_calling_diagram.png" alt="Function calling workflow diagram showing the interaction between developer, model, and function execution" style={{ maxWidth: '50%' }} />
              <p className="image-credit">Diagram courtesy of OpenAI</p>
            </div>
          </Link>
        </article>

      </div>
    </div>
  );
}

export default Blog;
